// Header
import {React, useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import Nav from './Nav';

const Header = () => {

	const [navOpen, setNavOpen] = useState(false);
	const [darkLogo, setDarkLogo] = useState(false);

	const showHideNav = () => {
		setNavOpen(!navOpen);
	}

	const hideNav = () => {
		setNavOpen(false);
	}

	const {pathname} = useLocation();

	const setLogo = () => {
		if (pathname === "/") {
			setDarkLogo(true);
		} else {
			setDarkLogo(false);
		}
	}

	document.addEventListener("DOMContentLoaded", setLogo);


	return (

		<header>
			<div className="site-header">
				<h1 className={darkLogo ? "site-logo dark-logo" : "site-logo"}><Link to={'/'}><span>K</span>irsten <span>K.</span></Link></h1>
				<button className={navOpen ? "btn-main-nav open" : "btn-main-nav"} onClick={showHideNav}>
					
					<span className="line"></span>
					<span className="line"></span>
					<span className="line"></span>
					
					<span className="sr-only">Menu</span>
				</button>
			</div>
			<div className="site-nav">
				<Nav navOpen={navOpen} hideNav={hideNav}/>
				<span className={navOpen ? "nav-bg active" : "nav-bg not-active"}></span>
			</div>
		</header>
    
	);

}

export default Header;